import { gql } from '@apollo/client'

// Stored as its own ACF field group on the page rather than a page-builder layout, so it
// is queried directly off the page instead of through the flexibleContent field.
export const LeaderProfileFieldsFragment = gql`
  fragment LeaderProfileFields on Page {
    leaderProfile {
      eyebrow
      leaderName
      intro
      bioHeading
      bio
      headshot {
        node {
          altText
          sourceUrl(size: MEDIUM_LARGE)
        }
      }
      backgroundImage {
        node {
          altText
          sourceUrl
        }
      }
      connectLink {
        url
        title
        target
      }
      socialLinks {
        platform
        url
      }
    }
  }
`
